import { DocumentoPrenotaParams } from '../../../../models';
import { apiClient } from '../../../../helpers';
import { AxiosResponse } from 'axios';
import {
  handleError,
  URL_GESTIFY_DOCUMENTI,
  URL_PRENOTA,
} from '../../../../utils';
import { getGestifyTokenCookies } from '../../../../helpers/authCookies';

export const gestifyPrenotaDfveDocumento = async (
  parameters: DocumentoPrenotaParams,
) => {
  try {
    const token = getGestifyTokenCookies().gestifyToken;
    const { documento, ...params } = parameters;
    const response = await apiClient.post<AxiosResponse>({
      url: `${URL_GESTIFY_DOCUMENTI}/${documento}${URL_PRENOTA}`,
      params: { ...params, token },
    });
    console.log('gestifyPrenotaDfveDocumento', { response });
    if (response.status >= 200 || response.status < 300) {
      return { data: response.data, params };
    }

    return handleError(response.status, response.data?.status);
  } catch (error: any) {
    return handleError(
      error?.response?.status ?? error?.message,
      error?.response?.data,
    );
  }
};
